import React from "react";

import PropTypes from "prop-types";

import useRbSwipeViewItemStyles from "./useRbSwipeViewItemStyles";

function RbSwipeViewItem(props) {
  const { children, ...others } = props;

  const classes = useRbSwipeViewItemStyles();

  return (
    <div
      {...others}
      classes={classes.root}
      style={{ width: "100%", position: "relative" }}
    >
      {children}
    </div>
  );
}

RbSwipeViewItem.propTypes = {
  children: PropTypes.node,
};

RbSwipeViewItem.defaultProps = {
  children: null,
};

export default React.memo(RbSwipeViewItem);
